<template>
  <div class="flex items-center">
      <button class="check" @click.prevent="toggle" @keydown.space.prevent="toggle">
        <font-awesome-icon :icon="['far', value ? 'check-square' : 'square']" />
      </button>
      <div class="ml-1" :class="{ 'font-bold': value }">
        <slot />
      </div>
    </div>
</template>

<script>
export default {
  name: 'checkbox',
  props: ['value'],
  methods: {
    toggle () {
      this.$emit('input', !this.value)
    }
  }
}
</script>